import React, { useEffect, useRef, useState } from "react";

export const Features = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // Load video when section is visible
          if (videoRef.current) {
            videoRef.current.load();
          }
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px",
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div id="features" className="text-center features-section" ref={sectionRef}>
      {/* <video
        ref={videoRef}
        className="features-video-background"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        onLoadStart={() => console.log('Video loading...')}
        onCanPlay={() => console.log('Video ready to play')}
        onError={(e) => console.log('Video error:', e)}
      >
        <source src="img/avhi_goldlow_high_1.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video> */}
      <div className="features-texture"></div>
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Why Choose AHVI Gold - Best Gold Buyers</h2>
          <p>
            We are committed to providing the best gold buying experience with
            transparent evaluation, fair market rates, and instant cash payments.
            Certified experts using advanced equipment for accurate gold appraisal.
          </p>
        </div>
        <div className="row features-row">
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.title}-${i}`}
                  className={`col-xs-6 col-md-3 feature-item ${
                    isVisible ? "animate" : ""
                  } ${i % 2 === 0 ? "from-left" : "from-right"}`}
                  style={{ animationDelay: `${i * 0.15}s` }}
                >
                  <div className="feature-icon-wrapper">
                    <img src={d.icon} alt={d.title} className="team-img" />
                  </div>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : <div className="loading">Loading...</div>}
        </div>
      </div>
    </div>
  );
};

export default Features;